__webpack_require__.p = "https://fantasy.motogp.com/";